import React from "react";
import Section from "Section";
export default function Header() {
  const stats = [
    {
      logo: "far fa-heart",
      name: "hackers",
      num: "800+",
    },
    {
      logo: "far fa-hourglass",
      name: "hours",
      num: "48",
    },
    {
      logo: "fas fa-trophy",
      name: "in Prizes",
      num: "$20k+",
    },
  ];
  return (
    <Section bcolor="#39485C">
      <div className="stats-con">
        {stats.map(({ logo, num, name }) => (
          <div className="stats-sin">
            <div>
              <div className="stats-sin__logo">
                <i className={logo}></i>
              </div>
              <div className="stats-sin__num">{num}</div>
            </div>
            <div className="stats-sin__text">{name}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}
